// web-staking-estimator-frontend/src/hooks/useAppReset.js
import { useCallback } from "react";

/**
 * Hook to provide a reset function that clears all form state
 * while preserving the service type selection.
 */
export function useAppReset({
  requestInfo,
  setRequestInfo,
  setSelectedPoint,
  setEstimate,
  setResetSignal,
  setSubmitMsg,
  setEstimateErr,
}) {
  const handleStartOver = useCallback(() => {
    // Ensure any overlays/spinners and messages are cleared before resetting
    setSubmitMsg(null);
    setEstimateErr(null);

    // Preserve service type; reset dependent fields
    setRequestInfo({
      svc_type: requestInfo.svc_type,
      svc_phase: null,
      svc_volts: null,
      svc_amps: null,
      matched_service_id: null,
      svc_ohug: null,
    });

    // IMPORTANT: keep selectedPoint's shape (don't set to null)
    setSelectedPoint({
      latitude: null,
      longitude: null,
      x: null,
      y: null,
      wkid: null,
    });

    // Clear current estimate summaries/results (consistent shape)
    setEstimate({
      distanceFeet: null,
      total: null,
      range: { low: null, high: null },
      lvSubtotal: null,
      mvSubtotal: null,
      mapImageDataUrl: null,
    });

    // Tell MapComponent to clear graphics and reset extent
    setResetSignal((n) => n + 1);
  }, [
    requestInfo.svc_type,
    setRequestInfo,
    setSelectedPoint,
    setEstimate,
    setResetSignal,
    setSubmitMsg,
    setEstimateErr,
  ]);

  return { handleStartOver };
}
